import getCurrentUser from 'src/apollo/queries/getCurrentUser.gql'
import { actionToken, consoleLogAPI } from 'src/common/functions'
import { userService } from 'src/common/user-service'
import refreshToken from 'src/apollo/mutations/refreshToken.gql'
import { TokenService } from 'src/common/token-service'
import { useUserAuthStore } from 'src/stores/user/auth'
import { sentrySetUser } from 'src/common/sentry'

const tokenService = new TokenService()

export async function authByToken(apolloClient) {
  let token = tokenService.getToken()
  let user = null

  if (!token) {
    return tokenService.removeToken()
  }

  useUserAuthStore().updateToken(token)

  user = await apolloClient
    .query({
      query: getCurrentUser,
    })
    .then(({ data }) => {
      return data?.currentUser ?? null
    })
    .catch((error) => {
      console.error('Token was removed. apollo/auth | 40')
      consoleLogAPI(error)
      useUserAuthStore().updateToken(null)
      userService.logout()
    })

  if (user?.language) {
    localStorage.setItem('u_lang', user.language)
  }

  if (token && user) {
    const actionTokenType = actionToken(token)

    if (actionTokenType === 'remove') {
      await userService.logout()
    } else if (actionTokenType === 'refresh') {
      await apolloClient
        .mutate({
          mutation: refreshToken,
          variables: { token },
        })
        .then(({ data }) => {
          useUserAuthStore().updateToken(data.refreshToken.token)
          useUserAuthStore().updateAuth(true)
          useUserAuthStore().updateUser(user)
          tokenService.setToken(data.refreshToken.token)

          sentrySetUser(user)
        })
        .catch(async (e) => {
          consoleLogAPI(e)
          await userService.logout()
        })
    } else {
      useUserAuthStore().updateToken(token)
      useUserAuthStore().updateAuth(true)
      useUserAuthStore().updateUser(user)

      sentrySetUser(user)
    }
  }
}
